module.exports = __webpack_public_path__ + "img/__icon_PODKONTENEROWA_STANDARD.87aff97c.svg";